import { get } from "lodash";
export var waitPromise = function (time) {
    if (time === void 0) { time = 20; }
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
};
export var hangPromise = function () {
    return new Promise(function () { });
};
export var isPromise = function (promise) { return !!promise && "then" in promise; };
/**
 * @author: Richard 23/1/2018
 * @description: Execute an Array of functions that return a promise in serial. All promises must resolve/reject before
 * it returns anything.
 * This can be used for throttling API calls (send one by one)
 * @example
 *
 * const users = [{name: "Bob"}, {name: "Fred"}]
 * const funcs = users.map((user) => () => this.handleCreate(user))
 *
 * promiseSerialAll(funcs)
 *  .then((Array responses) => {})
 *  .catch((Array rejects) => {})
 */
export var promiseSerialAll = function (arr) {
    if (arr === void 0) { arr = []; }
    if (get(arr, "length", 0) === 0) {
        return waitPromise();
    }
    var success = [];
    var errors = [];
    var runPromise = function (func) {
        return func()
            .then(function (res) { return success.push(res); })
            .catch(function (err) { return errors.push(err); });
    };
    var previous = runPromise(arr[0]);
    arr.slice(1).forEach(function (func) {
        previous = previous.then(function () { return runPromise(func); });
    });
    previous.then(function () {
        if (errors.length) {
            throw new Error(errors);
        }
        return success;
    });
    return previous;
};
